<template>
  <div>
    <div class="opo02">
      <span class="opo03" @click="back">刀具柜列表 ></span>
      <span class="opo04"> 货道配置</span>
    </div>
    <div class="hds01">
      <div class="hds08" v-for="(item,index) in data" :key="'lis'+index">
        <div class="hds02" v-for="(ite,ind) in item" :key="'liss'+ind">
          <div class="hds03">{{ite.code}}</div>
          <div class="hds05">
            <img src="@/assets/images/del01.png" @click="del(ite)" class="hds04" alt="" v-show="item.length == ind+1">
          </div>
        </div>
        <div class="hds06">
          <img src="@/assets/images/jia01.png" @click="jias(item)" class="hds07" alt="">
        </div>
      </div>
      <div class="hds08">
        <div class="hds06">
          <img src="@/assets/images/jia01.png" class="hds07" alt="" @click="jiah()">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djghd",
    data(){
      return{
        sbid:'',
        data:[],
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      me.sbid = me.$route.query.id;
      let data = {
        deviceid:me.sbid,
      }
      httpUser.channellist(data).then(res => {
        me.data = util.convert(res.data.datalist);
        console.log(me.data);
      })
    },
    methods:{
      del(ite){//删除货道
        if (ite.number2 == 1) {
          me.$message.error('每排第一列禁止删除');
          return false;
        }
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        // console.log(ite);return false;
        me.$confirm('是否删除货道?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          me.$Loading.start();
          let data = {
            id:ite.id,
          }
          httpUser.delchannel(data).then(res => {
            switch (res.code) {
              case "0000":
                let data = {
                  deviceid:me.sbid,
                }
                httpUser.channellist(data).then(res => {
                  me.data = util.convert(res.data.datalist);
                  me.$Loading.finish();
                  me.$message.success('已删除该货道');
                })
                break;
              case "1111":
                me.$Loading.error();
                me.$message.error('请稍后再试');
                break;
            }
          })
        }).catch(() => {
        });
      },
      jiah(){//添加行
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        let data = {
          code:'',
          deviceid:me.sbid,
          number1:1,
          number2:1,
        }
        if (me.data.length != 0) {
          data['number1'] = me.data[me.data.length-1][me.data[me.data.length-1].length-1].number1+1;
          data['code'] = ''+data['number1']+'-1'
        } else {
          data['code'] = ''+data['number1']+'-1'
        }
        httpUser.addorupdatecupchannel(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                deviceid:me.sbid,
              }
              httpUser.channellist(data).then(res => {
                me.data = util.convert(res.data.datalist);
                me.$Loading.finish();
                me.$message.success('已添加');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      jias(item){//添加货道
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        let data = {
          code:'',
          deviceid:me.sbid,
          number1:1,
          number2:1,
        }
        data['number1'] = item[item.length-1].number1;
        data['number2'] = item[item.length-1].number2+1
        data['code'] = ''+data['number1']+'-'+data['number2']+''
        httpUser.addorupdatecupchannel(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                deviceid:me.sbid,
              }
              httpUser.channellist(data).then(res => {
                me.data = util.convert(res.data.datalist);
                me.$Loading.finish();
                me.$message.success('已添加');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      back(){
        me.$router.back();
      },
    }
  }
</script>

<style scoped>
@import "djghd.css";
</style>